module.exports = __webpack_public_path__ + "img/web.5e5388a8.png";